<div class="fuse-card auto-width mb-12 mat-card mat-elevation-z2 p-0" [ngClass.gt-sm]="'mb-0'">

    <div class="title-height" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="h3 pr-16 cardHeader">Actuaciones</div>
        <div *ngIf="actuationService.Actuations">
            <mat-menu #menu="matMenu">
                <button *ngIf="sharedService.Permissions.HasPermisos605" mat-menu-item
                    [routerLink]="['/employee/create-actuation/visit',this.actuationService.CurrentLeaveId,actuationOperation.Visita]">
                    Visita
                </button>
                <button *ngIf="sharedService.Permissions.HasPermisos605" mat-menu-item
                    [routerLink]="['/employee/create-actuation/visit',this.actuationService.CurrentLeaveId,actuationOperation.VisitaAusente]">
                    Visita Ausente
                </button>
<!--                 <button *ngIf="sharedService.Permissions.HasPermisos605" mat-menu-item
                    [routerLink]="['/employee/create-actuation/visit',this.actuationService.CurrentLeaveId,actuationOperation.VisitaVideoconsulta]">
                    Visita por Videoconsulta
                </button> -->
                <button *ngIf="sharedService.Permissions.HasPermisos604" mat-menu-item
                    [routerLink]="['/employee/create-actuation/visit',this.actuationService.CurrentLeaveId,actuationOperation.PrimerContacto]">
                    Primer contacto
                </button>
                <button *ngIf="sharedService.Permissions.HasPermisos604" mat-menu-item
                    [routerLink]="['/employee/create-actuation/visit',this.actuationService.CurrentLeaveId,actuationOperation.Contacto]">
                    Llamada seguimiento
                </button>
                <button *ngIf="sharedService.Permissions.HasPermisos604" mat-menu-item
                    [routerLink]="['/employee/create-actuation/visit',this.actuationService.CurrentLeaveId,actuationOperation.ContactoFallido]">
                    Contacto Fallido
                </button>
                <button *ngIf="sharedService.Permissions.HasPermisos608" mat-menu-item
                    [routerLink]="['/employee/Contacto-administrativo',this.actuationService.CurrentLeaveId,actuationOperation.ContactoAdministrativo]">
                    Contacto Administrativo
                </button>
                <button *ngIf="sharedService.Permissions.HasPermisos608" mat-menu-item
                    [routerLink]="['/employee/Contacto-Administrativo-No-Contesta',this.actuationService.CurrentLeaveId,actuationOperation.ContactoAdministrativoNoContesta]">
                    Contacto Administrativo No Contesta
                </button>
                <!-- <button *ngIf="AllowToCreateActuation && (sharedService.Permissions.HasPermisos608 || sharedService.Permissions.HasPermisos623)" mat-menu-item>
                    Citación
                </button> -->

                <button *ngIf="sharedService.Permissions.HasPermisos608 && isLeaveClosed == false" mat-menu-item
                    [routerLink]="['/employee/pedir-cita',this.actuationService.CurrentLeaveId]">Pedir cita</button>

                <button *ngIf="sharedService.Permissions.HasPermisos623 && isLeaveClosed == false" mat-menu-item
                    [routerLink]="['/employee/citacion',this.actuationService.CurrentLeaveId]">Citación</button>

                <button mat-menu-item *ngIf="sharedService.Permissions.HasPermisos604"
                    [routerLink]="['/employee/gestion-con-mutua',this.actuationService.CurrentLeaveId,actuationOperation.GestionConMutua]">
                    Gestión con Mutua
                </button>
                <button mat-menu-item *ngIf="sharedService.Permissions.HasPermisos619"
                    [routerLink]="['/employee/solicitud',this.actuationService.CurrentLeaveId,actuationOperation.Solicitud]">
                    Solicitud
                </button>
                <button *ngIf="sharedService.Permissions.HasPermisos608" mat-menu-item
                    [routerLink]="['/employee/create-inspection',this.actuationService.CurrentLeaveId, InspectionType.Presentation, 0]">
                    Presentación a Inspección
                </button>
                <button mat-menu-item
                    *ngIf="sharedService.Permissions.HasPermisos607 || sharedService.Permissions.HasPermisos627"
                    [routerLink]="['/employee/comentario',this.actuationService.CurrentLeaveId, actuationOperation.Comentarios]">
                    Comentario
                </button>
                <button mat-menu-item *ngIf="sharedService.Permissions.HasPermisos618"
                    [routerLink]="['/employee/ordern',this.actuationService.CurrentLeaveId, actuationOperation.Orden]">
                    Orden
                </button>
                <button mat-menu-item *ngIf="sharedService.Permissions.HasPermisos605"
                    [routerLink]="['/employee/solicitar-alta',this.actuationService.CurrentLeaveId, actuationOperation.SolicitarAlta]">
                    Solicitar alta
                </button>
                <button mat-menu-item *ngIf="sharedService.Permissions.HasPermisos605"
                    [routerLink]="['/employee/mantener-it',this.actuationService.CurrentLeaveId, actuationOperation.MantenerIt]">
                    Mantener IT
                </button>
            </mat-menu>
            <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon class="mat-icon material-icons mat-icon-no-color f-s-19">add</mat-icon>
            </button>
        </div>
    </div>
    <div class="p-10 pt-0 height-450">
        <div *ngIf="actuationService.IsLoading == false">
            <table class="employee-actiation">
                <caption></caption>
                <thead>
                    <th></th>
                    <th></th>
                </thead>
                <tbody>
                    <tr *ngFor="let actuacionsDetails of actuationService.Actuations">
                        <!-- Menu -->
                        <td class="w-5-txt-a-center">
                            <span [matMenuTriggerFor]="ActuationOptions"
                                *ngIf="sharedService.Permissions.HasPermisos501">
                                <mat-icon
                                    class="mat-icon material-icons mat-icon-no-color f-s-15 color-blueviolet doc-option"
                                    role="img" aria-hidden="true">
                                    more_vert
                                </mat-icon>
                            </span>

                            <mat-menu #ActuationOptions="matMenu" class="actuaciones-menu">
                                <!-- <button mat-menu-item *ngIf="sharedService.Permissions.HasPermisos501"
                                    (click)="OpenEditActionText(actuacionsDetails)">
                                    <mat-icon class="font-size-14 m-r-0">edit</mat-icon> Editar
                                </button> -->
                                <button mat-menu-item (click)="EditActuation(actuacionsDetails)">
                                    <mat-icon class="font-size-14 m-r-0">edit</mat-icon> Editar
                                </button>

                                <button mat-menu-item *ngIf="sharedService.Permissions.HasPermisos620"
                                    (click)="openCutActuationsDialog(actuacionsDetails)">
                                    <span class="fa fa-scissors" aria-hidden="true"></span>
                                    Cortar
                                </button>

                                <button mat-menu-item *ngIf="sharedService.Permissions.HasPermisos616"
                                    (click)="DeleteActionConfirmation(actuacionsDetails)">
                                    <mat-icon class="font-size-14 m-r-0 delete-icon">delete_forever</mat-icon> Eliminar
                                </button>

                                <button mat-menu-item *ngIf="IsMenuVisible && actuacionsDetails.tipo === 13001"
                                    [routerLink]="['/employee/aknowledgement',this.actuationService.CurrentLeaveId,13013]">
                                    Entregado debidamente
                                </button>
                                <button mat-menu-item *ngIf="IsMenuVisible && actuacionsDetails.tipo === 13001"
                                    [routerLink]="['/employee/aknowledgement',this.actuationService.CurrentLeaveId,13014]">
                                    Casa cerrada
                                </button>
                                <button mat-menu-item *ngIf="IsMenuVisible && actuacionsDetails.tipo === 13001"
                                    [routerLink]="['/employee/aknowledgement',this.actuationService.CurrentLeaveId,13015]">
                                    Dirección incorrecta
                                </button>
                                <button mat-menu-item *ngIf="IsMenuVisible && actuacionsDetails.tipo === 13001"
                                    [routerLink]="['/employee/aknowledgement',this.actuationService.CurrentLeaveId,13016]">
                                    Sin notificación
                                </button>
                                <button mat-menu-item *ngIf="IsMenuVisible && actuacionsDetails.tipo === 14001"
                                    [routerLink]="['/employee/aknowledgement',this.actuationService.CurrentLeaveId,14011]">
                                    Entregado
                                </button>
                                <button mat-menu-item *ngIf="IsMenuVisible && actuacionsDetails.tipo === 14001"
                                    [routerLink]="['/employee/aknowledgement',this.actuationService.CurrentLeaveId,14019]">
                                    No entregado
                                </button>

                                <button mat-menu-item
                                    *ngIf="IsMenuVisible && InspectionTypeList.includes(actuacionsDetails.tipo)"
                                    [routerLink]="['/employee/create-inspection',this.actuationService.CurrentLeaveId, InspectionType.Visit, actuacionsDetails.actuacionId]">
                                    Visita inspección
                                </button>

                                <button mat-menu-item
                                    *ngIf="IsMenuVisible && InspectionTypeList.includes(actuacionsDetails.tipo)"
                                    [routerLink]="['/employee/create-inspection',this.actuationService.CurrentLeaveId, InspectionType.Response, actuacionsDetails.actuacionId]">
                                    Respuesta inspección
                                </button>

                                <button mat-menu-item
                                    *ngIf="IsMenuVisible && actuacionsDetails.tipo >= 36001 && actuacionsDetails.tipo <= 36039"
                                    (click)="openEditSolicitudDialog(actuacionsDetails.actuacionId)">
                                    Modificar solicitud
                                </button>

                                <button mat-menu-item *ngIf="IsMenuVisible && actuacionsDetails.tipo === 30111"
                                    (click)="OpenMarcarAsuenciaJustificadaDialog(actuacionsDetails)">
                                    Marcar ausencia justificada
                                </button>

                                <button mat-menu-item *ngIf="IsMenuVisible && actuacionsDetails.tipo === 30111"
                                (click)="OpenQuitarMarcaAsuenciaJustificadaDialog(actuacionsDetails)">
                                Quitar marca de ausencia justificada
                                </button>

                                <button mat-menu-item *ngIf="IsMenuVisible && sharedService.Permissions.HasPermisos608"
                                    (click)="openEditActionTypeDialog(actuacionsDetails.actuacionId)">
                                    Corregir tipo de actuación
                                </button>
                            </mat-menu>
                        </td>

                        <!-- Icon -->
                        <td class="w-5-txt-a-center">
                            <span class={{actuacionsDetails.iconSrc}}></span>
                        </td>

                        <!-- Date -->
                        <td class="date-w">
                            <span>{{actuacionsDetails.fecha | date :'dd/MM/yyy'}}</span>
                        </td>

                        <!-- Time -->
                        <td class="w-hora"><span>{{actuacionsDetails.hora |date:'HH:mm'}}</span></td>

                        <!-- Lock/Unlock -->
                        <td class="titlecase-w" *ngIf="!employeeService.isEmployeeLocked">
                            <span>{{actuacionsDetails.actuacion | uppercase}}</span>
                        </td>

                        <!-- Type and comment -->
                        <td>
                            <span
                                *ngIf="actuacionsDetails.texto != null && actuacionsDetails.texto != '' && IsTextoFieldVisible"
                                class="border-none">
                                <span id="content" [innerHTML]="ShowCompactText(actuacionsDetails) | htmlFormatter">
                                </span>
                                
                                <span
                                    *ngIf="(actuacionsDetails.texto.length > 115 || (actuacionsDetails.comentarioParaEmpresa && actuacionsDetails.comentarioParaEmpresa.length > 115)) && (actuacionsDetails.showSeemore === undefined || actuacionsDetails.showSeemore)"
                                    aria-label="search" class="actuation-btn fa fa-ellipsis-h p-0"
                                    (click)="clickSeeMore(actuacionsDetails)">
                                </span>
                            </span>
                        </td>

                        <!-- Author -->
                        <td class="actiation-author">
                            <span>{{actuacionsDetails.autor |titlecase}}</span>
                        </td>

                        <!-- Registro and User -->
                        <td>
                            <mat-icon class="info-icon" *ngIf="actuacionsDetails.registroHint"
                                matTooltipClass="formatted" matTooltip="{{actuacionsDetails.registroHint}}">
                                info
                            </mat-icon>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div *ngIf="actuationService.IsLoading == true" class="m-auto">
            <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
            </mat-progress-spinner>
        </div>
    </div>
</div>